import {connect} from 'react-redux';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import InfoList from "../../shared/infolist";
import {Button} from "antd";
import {withRouter} from 'react-router-dom';
import * as APP_CONFIG from "../../../constants/config";
const {benchmarkApi} = APP_CONFIG;


class LocationList extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,
        showTitle: PropTypes.bool
    };

    static defaultProps = {
        showTitle: true
    }

    loadPage = (id) => {
        console.log("load location", id)
        this.props.history.push(`/locaties/${id}`)
    }

    render() {
        return (
            <Fragment>
                {
                    this.props.showTitle ?
                        <h1>Locaties</h1> : ''
                }
                <InfoList dataSourceFunc={async () => {
                    const request = await fetch(`${benchmarkApi}locations`);
                    const data = await request.json();
                    return data;
                }} columns={[
                    {
                        title: '#',
                        dataIndex: 'id',
                    }, {
                        title: 'Locatie',
                        dataIndex: 'name',
                    }, {
                        title: 'Plaats',
                        dataIndex: 'city_name'
                    }, {
                        title: 'Acties',
                        dataIndex: 'x',
                        render: (text, row, index) => <Button onClick={() => this.loadPage(row.id)}>Bekijken</Button>,
                    }
                ]} rowKey="id" />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {return {}}

export default connect(mapStateToProps)(withRouter(LocationList));



// WEBPACK FOOTER //
// ./src/components/baseinfo/locations/list.js